import { render, staticRenderFns } from "./interviewDuration.vue?vue&type=template&id=48af9c19&scoped=true"
import script from "./interviewDuration.vue?vue&type=script&lang=js"
export * from "./interviewDuration.vue?vue&type=script&lang=js"
import style0 from "./interviewDuration.vue?vue&type=style&index=0&id=48af9c19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af9c19",
  null
  
)

export default component.exports